import api from "./Api";

class AdministradorService {
  AddRestricoesPadrao(payload) {
    return api
      .post("/v1/Administrador/AddRestricoesPadrao" + payload)
      .then((response) => {
        return response.data;
      });
  }

  GetRestricoesPadrao() {
    return api.get("/v1/Administrador/RestricoesPadrao").then((response) => {
      return response.data;
    });
  }

  AddRestricoes(payload) {
    return api
      .post("/v1/Administrador/AddRestricoes" + payload)
      .then((response) => {
        return response.data;
      });
  }

  AddEmitenteRestricoesPadrao(payload) {
    return api
      .post("/v1/Administrador/AddEmitenteRestricoesPadrao" + payload)
      .then((response) => {
        return response.data;
      });
  }

  GetEmitenteRestricoesPadrao() {
    return api
      .get("/v1/Administrador/EmitenteRestricoesPadrao")
      .then((response) => {
        return response.data;
      });
  }

  AddEmitenteRestricoes(payload) {
    return api
      .post("/v1/Administrador/AddEmitenteRestricoes" + payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new AdministradorService();
